module.exports = __webpack_public_path__ + "img/dun&bradstreet.2b30b581.svg";